import React from 'react';

import { Localize } from '@deriv-com/translations';

export const switch_to_tick_chart = {
    key: 'switch_to_tick_chart',
    header: <Localize i18n_default_text='This chart display is not ideal for tick contracts' />,
    message: <Localize i18n_default_text='Please change the chart duration to tick for a better trading experience.' />,
    type: 'info',
};
